// Initial-load placeholder for the message list. Three alternating-aligned
// pill shapes that read as a plausible transcript on first paint.
import { Flex } from '@chakra-ui/react';
import { ShimmerLoadingBar } from '@kula-ai/components';
import { colors } from '@/theme/foundations/colors';

const BUBBLES: Array<{
  align: 'flex-start' | 'flex-end';
  widthPct: string;
  heightPx: string;
}> = [
  { align: 'flex-start', widthPct: '70%', heightPx: '52px' },
  { align: 'flex-end', widthPct: '45%', heightPx: '36px' },
  { align: 'flex-start', widthPct: '60%', heightPx: '64px' },
];

export const ThreadBodySkeleton = () => (
  <Flex
    direction="column"
    gap="20px"
    data-test-id="thread-body-skeleton"
    aria-hidden
  >
    {BUBBLES.map((bubble, i) => (
      <Flex key={i} justify={bubble.align}>
        <ShimmerLoadingBar
          w={bubble.widthPct}
          h={bubble.heightPx}
          className="!rounded-xl"
          // The component's own inline `background` is a purple/blue gradient;
          // an inline style is the only thing that overrides it to a flat
          // secondary-100 base (the white shimmer sweep still animates on top).
          style={{ background: colors['secondary-100'] }}
        />
      </Flex>
    ))}
  </Flex>
);
